export default {
  en: {
    email: 'Email',
    agent: 'Agent',
    agentType: 'Agent Type',
    market: 'Market',
    status: 'Status',
    detail: 'Detail',
    totalSendEmail: 'Total Send Email',
    success: 'Success',
    fail: 'Fail',
    processing: 'Processing',
    clear: 'Clear',
    filterByKeyword: 'Filer by keyword',
    subject: 'Subject'
  },
  th: {
    email: 'อีเมล',
    agent: 'ตัวแทน',
    agentType: 'ประเภทของตัวแทน',
    market: 'ตลาด',
    status: 'สถานะ',
    detail: 'รายละเอียด',
    totalSendEmail: 'อีเมลทั้งหมด',
    success: 'สำเร็จ',
    fail: 'ไม่สำเร็จ',
    processing: 'กำลังส่ง',
    clear: 'ล้างค่า',
    filterByKeyword: 'คำค้นหา',
    subject: 'เรื่อง'
  }
}
